/**我的钱包**/
<template>
  <div class="meWallet">
    <div class="balance">
      <div class="content">
        <p>账户余额（元）</p>
        <h2>
          {{((postCustomerPreSave.present_balance || 0) + (postCustomerPreSave.non_present_balance || 0)).toFixed(2)}}</h2>
        <span><i class="iconfont icon-gth"></i>支付费用时优先使用</span>
      </div>
    </div>
    <div class="balanceBut" v-if="wxState">
      <span class="But"><router-link to="/recharge">充值</router-link></span>
    </div>
    <div class="page1 page">
      <ul class="pageItme">
        <li>
          <router-link :to="'/capitalRecord'">
            <span class="Icon">
              <i class="iconfont icon-zijinmingxi"></i>
            </span>
            资金流水
            <i class="iconfont icon-jiantou"></i>
          </router-link>
        </li>
        <li>
          <router-link :to="'/coupon/nused'">
            <span class="Icon">
              <i class="iconfont icon-youhuiquanicon"></i>
            </span>
            优惠券
            <i class="iconfont icon-jiantou"></i>
            <span class="text">{{couponData.length}}张</span>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <div class="page2 page">
      <ul class="pageItme">
        <li>
          <router-link :to="'/invoice'">
            <span class="Icon">
              <i class="iconfont icon-fapiao"></i>
            </span>
            发票申请
            <i class="iconfont icon-jiantou"></i>
          </router-link>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'meWallet',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        wxState: 'wxState',
        postCustomerPreSave: 'postCustomerPreSave',
        unusedCoupons: 'unusedCoupons'
      })
    },
    data () {
      return {
        couponData: []
      }
    },
    methods: {
      postCustomerPreSaveFn () { // 获取 用户余额
        let that = this
        that.$store.dispatch('postCustomerPreSave', {
          id: that.loginData.passenger.id
        })
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        console.log(that.loginData)
        // that.$store.dispatch('updateLoginData', {passengerId: that.loginData.passenger.id})
        that.$store.dispatch('getCouponType', {
          channel: 'wechat',
          page: 1,
          limit: 80,
          fn (data) {
            if (data && data.code === 1) {
              let arr = []
              if (data.coupon) {
                data.coupon.forEach(item => {
                  if (item.state === 1) {
                    var endTime = item.end_time
                    if (endTime) {
                      if (new Date().valueOf() < endTime * 1000) {
                        arr.push(item)
                      }
                    } else {
                      arr.push(item)
                    }
                  }
                })
              }
              that.couponData = arr
            }
          }
        })
        that.postCustomerPreSaveFn()
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .meWallet {
    width: 100vw;
    height: 100vh;
    background-color: #f3f4f5;
    .page {
      padding-top: 1rem;
      .pageItme {
        background-color: #fff;
      }
      li {
        box-sizing: border-box;
        padding: 0 1rem;
        margin: 0 1rem;
        border-bottom: 1px solid #f3f4f5;
        height: 3.666666rem;
        line-height: 3.666666rem;
        font-size: 1.25rem;
        a {
          color: #333333;
          width: 100%;
        }
        i {
          float: right;
          line-height: 3.666666rem;
          font-size: 1.2rem;
          color: #999999;
        }
        .Icon {
          float: left;
          margin-right: 0.91666rem;
          i {
            font-size: 1.4rem;
            color: #bbbbbb;
          }
        }
        .text {
          float: right;
          color: #999999;
          font-size: 1.25rem;
          margin-right: 1.025rem;
        }
      }
      li:nth-last-child(1) {
        border-bottom: none;
      }
    }
    .page2 {
      padding-bottom: 1rem;
    }
    .balance {
      text-align: center;
      background-color: #fff;
      padding: 1rem;
      p {
        margin-top: 3.33rem;
        color: #999999;
        font-size: 1rem;
      }
      h2 {
        color: #333333;
        font-size: 2.9rem;
        margin-top: 1.916rem;
        margin-bottom: 1.5rem;
      }
      span {
        font-size: 1rem;
        margin-bottom: 2.833rem;
        color: #999999;
        i {
          font-size: 1rem;
          margin-right: 0.1rem;
          color: #dfdfdf;
        }
      }
    }
    .balanceBut {
      padding: 0 2rem;
      margin-top: 2.5rem;
      margin-bottom: 1.5rem;
      .But {
        width: 100%;
        a {
          line-height: 4.25rem;
          height: 4.25rem;
          background-color: #f06552;
          overflow: hidden;
          border-radius: 0.333rem;
          width: 100%;
          text-align: center;
          color: #fff;
          font-size: 1.58rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// mewallet.vue?34538154